import React from 'react';
import {Redirect} from 'react-router';

export default function Authorization(allowedRoles) {
  return (WrappedComponent) =>
    class WithAuthorization extends React.Component {
      render() {
        const user = this.props.auth.userInfo;
        
        if (user && !user.attributes) {
          return <p>{JSON.stringify(user)}</p>;
        }
        const role = user ? user.attributes['custom:role'] : '';
        
        if (this.props.auth.isAuthenticated) {
          if (allowedRoles.includes(role)) {
            return <WrappedComponent {...this.props}/>;
          } else {
            return <h3>Unauthorized.</h3>; // TODO: Error Page
          }
        }

        return <Redirect to="/login"/>;
      }
  };
}


// WEBPACK FOOTER //
// ./src/components/user/Authorization.js